module.exports = __webpack_public_path__ + "img/vertical_1_1_1.fff5fdf2.png";